function productSearch(searchKeyword, callback) {
  $.ajax({
    type: 'GET',
    dataType: 'json',
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'productSearch',
      s: searchKeyword,
    },
    success: function (req) {
      if (req.data) {
        let products = ''
        req.data.forEach(item => {
          products += `
          <div class="stb-search-item">
            <div class="stb-search-item__thumbnail">
              <a href="${item.permalink}">
                <figure class="stb-search-item__img">
                  ${item.thumbnail}
                </figure>
              </a>
            </div>
            <div class="stb-search-item__content">
              <span class="stb-search-item__content-title"><a href="${item.permalink}">${item.title}</a></span>
              <span class="stb-search-item__content-info">${item.price}</span>
            </div>
          </div>`
        })
        callback(products)
      } else {
        callback('')
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log('The following error occured: ' + textStatus, errorThrown)
    },
  })
}

export default {
  productSearch,
}